export default __webpack_public_path__ + "static/media/expand.215eee6c.svg";